/* Copyright (C) 2025 Captor Fund Management AB - All Rights Reserved
 * Unauthorized copying or viewing of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Contact andreas.lindh@captor.se for information
 */

import gql from "graphql-tag";

export const OP_PAYMENTS_QUERY = gql`
    query opPayments($filter: OPPaymentFilter, $includeVersions: Boolean = false) {
        opPayments(filter: $filter) {
            _id
            createUserId
            createUserInfo {
                name
            }
            updateUserId
            updateUserInfo {
                name
            }

            clientId
            client {
                name
            }
            createTimestamp
            updateTimestamp
            transactionStatus
            paymentId
            signingBasketId
            authorizationId
            _links {
                scaRedirect {
                    href
                }
                scaOAuth {
                    href
                }
                startAuthorisation {
                    href
                }
                startAuthorisationWithPsuIdentification {
                    href
                }
                startAuthorisationWithPsuAuthentication {
                    href
                }
                startAuthorisationWithEncryptedPsuAuthentication {
                    href
                }
                startAuthorisationWithAuthenticationMethodSelection {
                    href
                }
                startAuthorisationWithTransactionAuthorisation {
                    href
                }
                self {
                    href
                }
                status {
                    href
                }
                scaStatus {
                    href
                }
            }
            transactionFees {
                amount
                currency
            }
            remittanceInformationStructured {
                reference
                referenceType
                referenceIssuer
            }
            tppMessages {
                category
                code
                text
            }
            debtorAccount {
                iban
            }
            instructedAmount {
                amount
                currency
            }
            creditorAccount {
                iban
            }
            creditorName
            endToEndIdentification
            creditorAgent
            remittanceInformationUnstructured
            debtorAccountMessage
            requestedExecutionDate
            versions @include(if: $includeVersions)
        }
    }
`;

export const OP_SIGNING_BASKET_AUTHORIZATION_QUERY = gql`
    query opSigningBasketAuthorization($signingBasketId: String!) {
        opSigningBasketAuthorization(signingBasketId: $signingBasketId) {
            status
            qrImage
        }
    }
`;
